import type { GridSize, Point } from "./types";

/** Rastgele, yılanın kapladığı hücrelere denk gelmeyecek bir yem konumu üretir. */
export function placeFood(grid: GridSize, snake: readonly Point[]): Point {
  while (true) {
    const p = {
      x: Math.floor(Math.random() * grid.cols),
      y: Math.floor(Math.random() * grid.rows),
    };
    if (!snake.some((s) => s.x === p.x && s.y === p.y)) return p;
  }
}
